var React = require('react');

function WarningFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30 30H0L15 0l15 30zm-14-6h-2v2h2v-2zm0-2V12h-2v10h2z","fillRule":"evenodd"}));
}

WarningFilled.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = WarningFilled;

WarningFilled.default = WarningFilled;
